import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMachinesFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 16,
	width: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m9.504 16 .672-2.08c.128-.064.31-.17.544-.32a.25.25 0 0 1 .064-.048l1.76.848 2.112-2.128-.832-1.792c.075-.15.165-.352.272-.608l1.904-.672v-3.024l-1.92-.656a12.506 12.506 0 0 0 -.272-.608l.848-1.776-2.128-2.128-1.792.912a4.198 4.198 0 0 0 -.592-.192l-.672-1.728h-2.96l-.656 1.696a.142.142 0 0 1 -.064.016c-.181.032-.363.08-.544.144l-1.808-.88-2.112 2.144.832 1.792a6.75 6.75 0 0 0 -.256.608l-1.904.656v3.024l1.904.672c.075.181.165.384.272.608l-.848 1.808 2.112 2.144 1.776-.8.224.112c.16.085.283.15.368.192l.672 2.064zm-1.504-6.208c-.33 0-.632-.08-.904-.24a1.797 1.797 0 0 1 -.648-.648 1.75 1.75 0 0 1 -.24-.904c0-.33.08-.632.24-.904s.376-.488.648-.648.573-.24.904-.24c.33 0 .632.08.904.24s.488.376.648.648.24.573.24.904c0 .33-.08.632-.24.904s-.376.488-.648.648a1.75 1.75 0 0 1 -.904.24z",
		fill: "#2b2b2b"
	})
});
export default SvgMachinesFilled;
